import { render, staticRenderFns } from "./JoinVideo.vue?vue&type=template&id=28a2c4de&scoped=true&"
import script from "./JoinVideo.vue?vue&type=script&lang=js&"
export * from "./JoinVideo.vue?vue&type=script&lang=js&"
import style0 from "./JoinVideo.vue?vue&type=style&index=0&id=28a2c4de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2c4de",
  null
  
)

export default component.exports